/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_Create_Owner_PasswordInputs */

const cs_franchise_create_owner_password = /** @type {(inputs: Franchise_Create_Owner_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Počáteční heslo majitele`)
};

const en_franchise_create_owner_password = /** @type {(inputs: Franchise_Create_Owner_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owner initial password`)
};

/**
* | output |
* | --- |
* | "Owner initial password" |
*
* @param {Franchise_Create_Owner_PasswordInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_create_owner_password = /** @type {((inputs?: Franchise_Create_Owner_PasswordInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_Create_Owner_PasswordInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_create_owner_password(inputs)
	return cs_franchise_create_owner_password(inputs)
});